module.exports = __webpack_public_path__ + "img/img_popup_kakao-sync.b5099298.png";